import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY, SUBSCRIBE_AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes, subscribeRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import SubscribeRoute from './SubscribeRoute';
import { useSelector } from 'react-redux';

const Routes = () => {

	const authData = useSelector( (state) => state.auth);

	let authEntry;
	if(authData?.user_type == 'admin'){
		authEntry = AUTHENTICATED_ENTRY
	}
	if(authData?.user_type == 'coach'){
		authEntry = SUBSCRIBE_AUTHENTICATED_ENTRY
	}
	

	return (
		<RouterRoutes>
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate replace to={authEntry} />} />
				{  
				
				protectedRoutes.map((route, index) => {
					//console.log(route.type == authData?.user_type)
					if(route.type == authData?.user_type){
						return (
							<Route 
								key={route.key + index} 
								path={route.path}
								element={
									<AppRoute
										routeKey={route.key} 
										component={route.component}
										{...route.meta} 
									/>
								}
							/>
						)
					}
					
				})
				}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>

			{/* <Route path="/subscription" element={<SubscribeRoute />}>
				<Route path="/subscription" element={<Navigate replace to={SUBSCRIBE_AUTHENTICATED_ENTRY} />} />
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
				<Route path="*" element={<Navigate to="/subscription" replace />} />
			</Route> */}

			<Route path="/" element={<PublicRoute />}>
				{ publicRoutes.map(route => {
					return (
						<Route 
							key={route.path} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/ >
					)
				})}
			</Route>

		</RouterRoutes>
	)
}

export default Routes